import React, { useMemo, useState } from "react";

interface QuickInquiryModalProps {
  isOpen: boolean;
  position: { top: number; left: number } | null;
  onClose: () => void;
}

export default function QuickInquiryModal({ isOpen, position, onClose }: QuickInquiryModalProps) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [dateToConnect, setDateToConnect] = useState("");
  const [goodTime, setGoodTime] = useState("");

  const isValid = useMemo(() => {
    return (
      name.trim().length > 0 &&
      email.trim().length > 0 &&
      dateToConnect.trim().length > 0 &&
      goodTime.trim().length > 0
    );
  }, [name, email, dateToConnect, goodTime]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!isValid) return;
    onClose();
    setName("");
    setEmail("");
    setMobile("");
    setDateToConnect("");
    setGoodTime("");
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed z-[120]"
      style={{
        top: position?.top ?? 96,
        left: position?.left ?? 16,
      }}
      role="dialog"
      aria-modal="false"
    >
      <div className="w-[360px] max-w-[calc(100vw-24px)] rounded-2xl bg-white p-4 shadow-2xl border border-[#dde5f2]">
        <div className="mb-3 flex items-center justify-between">
          <h1 className="text-[25px] leading-none font-bold text-[#1b2740]">Quick Enquiry</h1>
          <button
            type="button"
            onClick={onClose}
            className="absolute top-2 right-2 text-3xl w-10 h-10 flex items-center justify-center leading-none text-black hover:text-[#394a66]"
            aria-label="Close quick inquiry"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="Name"
            className="w-full h-10 rounded-md border border-[#c8d2e3] px-4 text-[13px] text-[#1f2b43] placeholder:text-[#90a0b8] focus:!ring-0 focus:!shadow-none focus:!outline-none focus:!border-[#c8d2e3]"
            required
          />

          <input
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="Email"
            type="email"
            className="w-full h-10 rounded-md !border !border-[#c8d2e3] px-4 text-[13px] text-[#1f2b43] placeholder:text-[#90a0b8] focus:!ring-0 focus:!shadow-none focus:!outline-none focus:!border-[#c8d2e3]"
            style={{ fontSize: "13px", lineHeight: "20px" }}
            required
          />

          <input
            value={mobile}
            onChange={(event) => setMobile(event.target.value)}
            placeholder="Mobile (optional)"
            className="w-full h-10 rounded-md border border-[#c8d2e3] px-4 text-[13px] text-[#1f2b43] placeholder:text-[#90a0b8] focus:!ring-0 focus:!shadow-none focus:!outline-none focus:!border-[#c8d2e3]"
          />

          <div className="relative">
            <input
              value={dateToConnect}
              onChange={(event) => setDateToConnect(event.target.value)}
              type="date"
              className="w-full h-10 rounded-md !border !border-[#c8d2e3] px-4 text-[13px] text-[#1f2b43] [&::-webkit-date-and-time-value]:text-[13px] [&::-webkit-datetime-edit]:text-[13px] focus:!ring-0 focus:!shadow-none focus:!outline-none focus:!border-[#c8d2e3]"
              style={
                !dateToConnect
                  ? { color: "transparent", fontSize: "13px", lineHeight: "20px" }
                  : { fontSize: "13px", lineHeight: "20px" }
              }
              required
            />
            {!dateToConnect && (
              <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-[13px] text-[#90a0b8]">
                Date to Connect
              </span>
            )}
          </div>

          <select
            value={goodTime}
            onChange={(event) => setGoodTime(event.target.value)}
            className={`w-full h-10 rounded-md border border-[#c8d2e3] px-4 text-[13px] focus:!ring-0 focus:!shadow-none focus:!outline-none focus:!border-[#c8d2e3] ${goodTime ? "text-[#1f2b43]" : "text-[#90a0b8]"}`}
            required
          >
            <option value="" disabled>
              Good Time To Connect
            </option>
            <option value="Morning">Morning</option>
            <option value="Afternoon">Afternoon</option>
            <option value="Evening">Evening</option>
          </select>

          <button
            type="submit"
            disabled={!isValid}
            className="w-full h-10 rounded-md !bg-[#2a62e6] !text-white border border-[#2a62e6] text-[16px] font-semibold disabled:!bg-[#82b0ff] disabled:!text-white disabled:!border-[#82b0ff] disabled:cursor-not-allowed"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
